import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
} from '@mui/material';
import { Construction } from '@mui/icons-material';

const AdminDashboard = () => {
  const navigate = useNavigate();

  return (
    <Container sx={{ mt: 4 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Construction sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h4" gutterBottom>
          Panel de Administración
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Módulo de administración en desarrollo
        </Typography>
        <Button variant="contained" onClick={() => navigate('/dashboard')}>
          Volver al Dashboard
        </Button>
      </Paper>
    </Container>
  );
};

export default AdminDashboard;
